import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import styles from './Proyectos.module.css';
import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';
import proyectosData from '../../../datos/proyectos.json';

const SeccionProyectos = () => {
  const [seccionRef, esVisible] = useScrollAnimation({ threshold: 0.08 });
  const [indice, setIndice] = useState(0);
  const [lightboxAbierto, setLightboxAbierto] = useState(false);

  // Obtener 30 imágenes aleatorias al montar
  const galeria = useMemo(() => {
    const shuffled = [...proyectosData].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 30);
  }, []);

  const anterior = () => setIndice(i => (i - 1 + galeria.length) % galeria.length);
  const siguiente = () => setIndice(i => (i + 1) % galeria.length);

  return (
    <section
      id="seccion-proyectos"
      ref={seccionRef}
      className={`${styles.seccion} ${esVisible ? styles.visible : ''}`}
    >
      <div className={`container ${styles.grid}`}>

        {/* ── Columna izquierda: texto ── */}
        <div className={styles.texto}>

          {/* Título palabra a palabra */}
          <h2 className={styles.titulo}>
            {['Nuestros', 'Proyectos'].map((palabra, i) => (
              <span
                key={i}
                className={`${styles.palabraWrap} ${esVisible ? styles.palabraVisible : ''}`}
                style={{ transitionDelay: `${i * 140}ms` }}
              >
                {i === 1
                  ? <span className={styles.acento}>{palabra}</span>
                  : palabra}
              </span>
            ))}
          </h2>

          {/* Línea animada bajo el título */}
          <div className={`${styles.lineaTitulo} ${esVisible ? styles.lineaVisible : ''}`} />

          {/* Párrafos con reveal de izquierda a derecha */}
          <p
            className={`${styles.parrafo} ${esVisible ? styles.parrafoVisible : ''}`}
            style={{ transitionDelay: '300ms' }}
          >
            Cada instalación representa nuestro compromiso con la excelencia. Descubre cómo transformamos operaciones industriales y comerciales con soluciones de alto rendimiento que garantizan ahorro y durabilidad.
          </p>
          <p
            className={`${styles.parrafo} ${esVisible ? styles.parrafoVisible : ''}`}
            style={{ transitionDelay: '420ms' }}
          >
            Desde sistemas de lavandería, hasta soluciones completas de aspiración industrial y tratamiento de superficies, nuestro catálogo de proyectos es prueba de nuestra dedicación al detalle.
          </p>

          <Link
            to="/proyectos"
            className={`btn btn-primary ${styles.cta} ${esVisible ? styles.ctaVisible : ''}`}
            style={{ transitionDelay: '560ms' }}
          >
            Ver galería de proyectos
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              strokeWidth={2} stroke="currentColor" width="18" height="18">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          </Link>
        </div>

        {/* ── Columna derecha: galería tipo flashcard ── */}
        <div className={`${styles.galeria} ${esVisible ? styles.galeriaVisible : ''}`}>
          <div className={styles.marcoCuadro} style={{ position: 'relative' }}>
            {galeria.map((proyecto, i) => {
              const isActive = i === indice;
              let transform = 'translateX(50px) scale(0.9) opacity(0)';
              let zIndex = 0;
              let opacity = 0;

              if (isActive) {
                transform = 'translateX(0) scale(1)';
                zIndex = 10;
                opacity = 1;
              }

              return (
                <img
                  key={proyecto.id || i}
                  src={proyecto.image}
                  alt={proyecto.title}
                  className={styles.foto}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transform,
                    zIndex,
                    opacity,
                    transition: 'all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1)',
                    display: 'block',
                    cursor: isActive ? 'pointer' : 'default'
                  }}
                  onClick={() => isActive && setLightboxAbierto(true)}
                />
              );
            })}

            <div className={styles.overlay} style={{ zIndex: 11 }} />

            <button className={`${styles.btnFlecha} ${styles.izq}`} onClick={anterior} aria-label="Anterior" style={{ zIndex: 12 }}>‹</button>
            <button className={`${styles.btnFlecha} ${styles.der}`} onClick={siguiente} aria-label="Siguiente" style={{ zIndex: 12 }}>›</button>
          </div>

          <div className={styles.etiqueta}>
            <span className={styles.etiquetaLinea} />
            <span className={styles.etiquetaTexto}>Proyectos Destacados</span>
          </div>
        </div>

      </div>

      {/* ── Modal Lightbox ── */}
      {lightboxAbierto && (
        <div className={styles.lightbox} onClick={() => setLightboxAbierto(false)}>
          <div className={styles.lightboxContent} onClick={e => e.stopPropagation()}>
            <button className={styles.closeBtn} onClick={() => setLightboxAbierto(false)}>
              ×
            </button>
            <button 
              className={`${styles.btnFlecha} ${styles.izq}`} 
              onClick={anterior} 
              aria-label="Anterior" 
              style={{ zIndex: 1200 }}
            >
              ‹
            </button>
            
            <img 
              src={galeria[indice].image} 
              alt={galeria[indice].title} 
              className={styles.lightboxImg} 
            />

            <button 
              className={`${styles.btnFlecha} ${styles.der}`} 
              onClick={siguiente} 
              aria-label="Siguiente" 
              style={{ zIndex: 1200 }}
            >
              ›
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default SeccionProyectos;
